import { pick } from "lodash";
import { SwitchAccountModel } from "../types/account";
import { ApiResponse } from "../types/api";
import { LoginResponse } from "../types/login";
import { UserModel } from "../types/user";
import Base from "./base";

export enum UserRoleEnum {
	OWNER = "owner",
	FDIR_ADMIN = "fdir_admin",
	FDIR = "fdir",
	USER = "user",
}

export enum AccountTypeEnum {
	Private = "Private",
	Company = "Company",
	Fdir = "Fdir",
}

export type CurrentUserClaims = {
	userId: string;
	sessionId: string;
	accountId: string;
	accountType: AccountTypeEnum;
	role: UserRoleEnum;
};

class AuthAPI extends Base {
	constructor(token: string) {
		super(token, "/api/auth");
	}

	async requestOtp(phoneNumber: string, action: string): Promise<ApiResponse> {
		return await this.postJsonWithQueryParams("/otp", "POST", {
			phoneNumber,
			action
		});
	}

	async updateTerms(termsAccepted: boolean): Promise<ApiResponse<UserModel>> {
		return await this.postJsonWithQueryParams("/terms", "POST", {
			termsAccepted,
		});
	}

	async login(phoneNumber: string, otp: string): Promise<ApiResponse<LoginResponse>> {
		return await this.postJsonWithQueryParams("/login", "POST", {
			phoneNumber,
			otp,
		});
	}

	async logout(): Promise<Response> {
		return await this.postJsonWithQueryParams("/logout", "DELETE", {});
	}

	async validateToken(): Promise<ApiResponse<CurrentUserClaims>> {
		return await this.fetchJsonWithQueryParams("/validateToken", "GET"); 
	}

	async getRefreshToken(): Promise<string> {
		const response:ApiResponse<string> = await this.fetchJsonWithQueryParams("/refreshToken", "GET"); 
		return response.isSuccess ? response.result ?? "" : "";
	}

	async switchAccount(accountId: string): Promise<ApiResponse<SwitchAccountModel>> {
		return await this.postJsonWithQueryParams("/switchAccount", "POST", {
			accountId
		});
	}

	async getTokenForSeamlessLogin() {
		const response: ApiResponse<string> = await this.fetchJsonWithQueryParams("/tokenForSeamlessLogin", "GET");
		return response.isSuccess ? response.result : "";
	}


	async getProfile(): Promise<ApiResponse<UserModel>> {
		return await this.fetchJsonWithQueryParams("/profile", "GET");
	}

	async updateUserInfo(user: UserModel): Promise<Response> {
		return await this.postJsonWithQueryParams("/profile", "PATCH", {
			...pick(user, ["firstName", "lastName", "email", "receiveSmsAlerts"]),
			languageCode: user.languageCode === "nb-NO" ? "no" : "en"
		});
	}

	async acceptInvite(accountId: string): Promise<ApiResponse> {
		return await this.postJsonWithQueryParams("/invitation/accept", "POST", { accountId });
	}

	async declineInvite(accountId: string): Promise<ApiResponse> {
		return await this.postJsonWithQueryParams("/invitation/decline", "POST", { accountId });
	}
}

export default AuthAPI;
